import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { userAccountTranslationChunksConfig } from '@spartacus/user/account/assets';
import { USER_ACCOUNT_FEATURE, UserAccountRootModule } from '@spartacus/user/account/root';
import { userProfileTranslationChunksConfig } from '@spartacus/user/profile/assets';
import { USER_PROFILE_FEATURE, UserProfileRootModule } from '@spartacus/user/profile/root';
import { customUserTranslationsChunksConfig, customUserTranslationsEn, customUserTranslationsEs } from '../../../../../public/translations/custom-user-translation-chunk-config';
import { en } from '../../../../../public/translations/en';
import { es } from '../../../../../public/translations/es';
import { CustomAddressBookModule } from './account/components/custom-address-book';
import { CustomLoginModule } from './account/components/custom-login/custom-login.module';
import { CustomRegisterComponentModule } from './profile/custom-register/custom-register.module';
import { CustomResetPasswordModule } from './profile/custom-reset-password-component';
import { CustomUpdatePasswordModule } from './profile/custom-update-password';
import { CustomUpdateProfileModule } from './profile/custom-update-profile/custom-update-profile.module';
@NgModule({
  declarations: [],
  imports: [
    UserAccountRootModule,
    UserProfileRootModule,
    CustomLoginModule,
    CustomRegisterComponentModule,
    CustomUpdateProfileModule,
    CustomUpdatePasswordModule,
    CustomAddressBookModule,
    CustomResetPasswordModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('@spartacus/user/account').then((m) => m.UserAccountModule)
        }
      }
    } as CmsConfig),
    provideConfig({
      i18n: {
        resources: { en: { userAccount: en.userAccount }, es: { userAccount: es.userAccount } },
        chunks: userAccountTranslationChunksConfig
      }
    } as I18nConfig),
    provideConfig({
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () => import('@spartacus/user/profile').then((m) => m.UserProfileModule)
        }
      }
    } as CmsConfig),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: {
            address: en.address,
            myAccountV2Email: en.myAccountV2Email,
            myAccountV2Password: en.myAccountV2Password,
            myAccountV2UserProfile: en.myAccountV2UserProfile,
            userProfile: en.userProfile
          },
          es: {
            address: es.address,
            myAccountV2Email: es.myAccountV2Email,
            myAccountV2Password: es.myAccountV2Password,
            myAccountV2UserProfile: es.myAccountV2UserProfile,
            userProfile: es.userProfile
          }
        },
        chunks: userProfileTranslationChunksConfig
      }
    }),
    provideConfig({
      i18n: {
        resources: { en: customUserTranslationsEn, es: customUserTranslationsEs },
        chunks: customUserTranslationsChunksConfig
      }
    } as I18nConfig),
    provideConfig({
      i18n: {
        resources: {
          en: {
            userAccount: {
              register: {
                ...en.userAccount.register,
                ...en.userProfile.register
              }
            }
          },
          es: {
            userAccount: {
              register: {
                ...es.userAccount.register,
                ...es.userProfile.register
              }
            }
          }
        }
      }
    } as I18nConfig)
  ]
})
export class UserFeatureModule {}
